import { jsx as s } from "@emotion/react/jsx-runtime";
import r, { alertClasses as l } from "@mui/material/Alert";
import a from "react";
import i, { alertTitleClasses as o } from "@mui/material/AlertTitle";
const C = l, m = a.forwardRef((e, t) => /* @__PURE__ */ s(r, { ref: t, ...e }));
m.displayName = "Alert";
const T = o, p = ({ ...e }) => /* @__PURE__ */ s(i, { ...e });
p.displayName = "AlertTitle";
export {
  m as A,
  C as a,
  T as b,
  p as c
};
